import { render, staticRenderFns } from "./AdminBrandsView.vue?vue&type=template&id=310b84f9&scoped=true&"
import script from "./AdminBrandsView.vue?vue&type=script&lang=js&"
export * from "./AdminBrandsView.vue?vue&type=script&lang=js&"
import style0 from "./AdminBrandsView.vue?vue&type=style&index=0&id=310b84f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310b84f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
